import styled from 'styled-components';
import { motion } from 'framer-motion';

export default styled(motion.div)(({ $withMaxWidth }) => [
  'position: absolute;',
  'min-width: 100%;',
  'height: 100%;',
  $withMaxWidth &&
    'max-width: 100%;' /* maxWidth: Necessary property to have overflow-wrap: break-word to work in the page */
]);
